module.exports = __webpack_public_path__ + "static/media/telegram-logo.c200c8ab.svg";